import React from 'react'

const String_rev = () => {
    return (
        <div className='container'>
            <h1>Program to reverse a string</h1>
            <div className='containers'>
           <code className='library'>#include</code>  &lt;stdio.h&gt; <br/>
           <code className='keywords'>int</code> main()<br/>
&#123;
<code className='keywords'>char</code> s[1000], r[1000];<br/>
<code className='keywords'>int </code>begin, end, count = 0;<br/>
<br/>
<code className='library'> printf</code>("Input a string\n");<br/>
<code className='keywords'> gets(s)</code>;<br/>
<br/>
<code className='comment'> // Calculating string length</code><br/>
<br/>
<code className='keywords'>while </code>(s[count] != '\0')<br/>
      count++;<br/>
<br/>
   end = count - 1;<br/>
<br/>
<code className='keywords'>for</code> (begin = 0; begin &lt; count; begin++) &#123;<br/>
      r[begin] = s[end];<br/>
      end--;<br/>
   &#125; <br/>
<br/>
   r[begin] = '\0';<br/>
<br/>
<code className='library'> printf</code>("%s\n", r);<br/>
<br/>
<code className='library'> return </code>0;<br/>
&#125; <br/>
            </div>
        </div>
    )
}

export default String_rev
